export default __webpack_public_path__ + "static/media/bernay18.10876772.jpg";